var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: { title: _vm.dialogTitle, visible: _vm.visible, width: "80%" },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        close: _vm.handleClose,
      },
    },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "el-form",
            {
              ref: "queryForm",
              staticClass: "query-section",
              attrs: { model: _vm.queryForm, "label-width": "100px" },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "终端编号：" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入入库SN",
                              clearable: "",
                            },
                            model: {
                              value: _vm.queryForm.posSnStart,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryForm, "posSnStart", $$v)
                              },
                              expression: "queryForm.posSnStart",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "截止SN：" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入截止SN",
                              clearable: "",
                            },
                            model: {
                              value: _vm.queryForm.posSnEnd,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryForm, "posSnEnd", $$v)
                              },
                              expression: "queryForm.posSnEnd",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c("span", { staticClass: "count-section" }, [
                            _vm._v("共" + _vm._s(_vm.tableData.length) + "件"),
                          ]),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.handleQuery },
                            },
                            [_vm._v("查询")]
                          ),
                          _c("el-button", { on: { click: _vm.handleReset } }, [
                            _vm._v("重置"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      ["hq_allocate", "branch_allocate"].includes(_vm.actionType)
        ? _c(
            "el-card",
            { staticClass: "box-card" },
            [
              _c(
                "el-form",
                {
                  ref: "formData",
                  staticClass: "query-section",
                  attrs: { model: _vm.formData, "label-width": "100px" },
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _vm.actionType === "hq_allocate"
                        ? _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "分公司：" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        placeholder: "请选择",
                                        clearable: "",
                                      },
                                      model: {
                                        value: _vm.formData.groupId,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.formData, "groupId", $$v)
                                        },
                                        expression: "formData.groupId",
                                      },
                                    },
                                    _vm._l(_vm.groupList, function (item) {
                                      return _c("el-option", {
                                        key: item.id,
                                        attrs: {
                                          label: item.name,
                                          value: item.id,
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.actionType === "branch_allocate"
                        ? _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "业务员：" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        placeholder: "请选择",
                                        clearable: "",
                                      },
                                      model: {
                                        value: _vm.formData.salesId,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.formData, "salesId", $$v)
                                        },
                                        expression: "formData.salesId",
                                      },
                                    },
                                    _vm._l(_vm.salesList, function (item) {
                                      return _c("el-option", {
                                        key: item.id,
                                        attrs: {
                                          label: item.name,
                                          value: item.id,
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticStyle: { width: "100%" },
          attrs: { data: _vm.tableData, stripe: "", border: "", height: "400" },
        },
        [
          _c("el-table-column", { attrs: { prop: "posSn", label: "终端号" } }),
          _c("el-table-column", {
            attrs: { prop: "platfromName", label: "平台名称" },
          }),
          _vm.actionType === "branch_callback"
            ? _c("el-table-column", {
                attrs: { prop: "groupName", label: "分公司" },
              })
            : _vm._e(),
          _vm.actionType === "branch_callback"
            ? _c("el-table-column", {
                attrs: { prop: "salesName", label: "业务员" },
              })
            : _vm._e(),
          _c("el-table-column", {
            attrs: { prop: "amountType", label: "终端类型" },
          }),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { disabled: _vm.submitLoading },
              on: { click: _vm.handleClose },
            },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.submitLoading },
              on: { click: _vm.handleConfirm },
            },
            [_vm._v("确认")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }